import { render, staticRenderFns } from "./BusinessCapability.vue?vue&type=template&id=4d8f5a72&scoped=true"
import script from "./BusinessCapability.vue?vue&type=script&lang=js"
export * from "./BusinessCapability.vue?vue&type=script&lang=js"
import style0 from "./BusinessCapability.vue?vue&type=style&index=0&id=4d8f5a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f5a72",
  null
  
)

export default component.exports